import { render, staticRenderFns } from "./view_content_details1.vue?vue&type=template&id=a8ef3998&scoped=true&"
import script from "./view_content_details1.vue?vue&type=script&lang=ts&"
export * from "./view_content_details1.vue?vue&type=script&lang=ts&"
import style0 from "./view_content_details1.vue?vue&type=style&index=0&id=a8ef3998&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8ef3998",
  null
  
)

export default component.exports